export const getRef = (ref: string) => ({
	ref: ref.split('/').reverse()[0],
	source: ref.split('/').reverse()[1],
})
